var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_11222_8427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check_circle_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00016 1.33301C11.6822 1.33301 14.6668 4.31767 14.6668 7.99967C14.6668 11.6817 11.6822 14.6663 8.00016 14.6663C4.31816 14.6663 1.3335 11.6817 1.3335 7.99967C1.3335 4.31767 4.31816 1.33301 8.00016 1.33301ZM8.00016 2.66634C6.58567 2.66634 5.22912 3.22824 4.22893 4.22844C3.22873 5.22863 2.66683 6.58519 2.66683 7.99967C2.66683 9.41416 3.22873 10.7707 4.22893 11.7709C5.22912 12.7711 6.58567 13.333 8.00016 13.333C9.41465 13.333 10.7712 12.7711 11.7714 11.7709C12.7716 10.7707 13.3335 9.41416 13.3335 7.99967C13.3335 6.58519 12.7716 5.22863 11.7714 4.22844C10.7712 3.22824 9.41465 2.66634 8.00016 2.66634ZM10.3568 5.58701C10.4765 5.46617 10.6379 5.39565 10.8079 5.38989C10.9778 5.38412 11.1436 5.44354 11.2712 5.55599C11.3988 5.66843 11.4786 5.8254 11.4943 5.99476C11.51 6.16412 11.4603 6.33306 11.3555 6.46701L11.3002 6.52967L7.57616 10.2543C7.44906 10.3814 7.27971 10.4574 7.10028 10.4679C6.92084 10.4783 6.74382 10.4225 6.60283 10.311L6.53883 10.2543L4.70016 8.41567C4.57933 8.29598 4.50881 8.13463 4.50304 7.96464C4.49727 7.79466 4.55669 7.6289 4.66914 7.50129C4.78159 7.37368 4.93855 7.29387 5.10791 7.27821C5.27727 7.26254 5.44622 7.31219 5.58016 7.41701L5.64283 7.47301L7.0575 8.88701L10.3575 5.58701H10.3568Z",
    fill: "#9DD8AC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11222_8427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckin);
export default __webpack_public_path__ + "static/media/checkin.9355dc103973a42ae9767d5e14a18c6d.svg";
export { ForwardRef as ReactComponent };